<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div class="form-card-wrapper">
          <b-card header-tag="header">
            <template #header>
              <b>Modifica configurazioni App</b>
            </template>
            <b-card-text>
              <!-- v-for="(report, index) in lisa_for_apps_reports" -->
              <div class="form-card-wrapper">
                <b-card
                  header-tag="header"
                  class="my-2"
                  v-for="(report, index) in lisa_for_apps_reports"
                  :key="index"
                ><template #header>
                  <b>{{ report.formatted_title }}</b>
                </template>
                  <b-row>
                    <div class="form-group">
                      <base-select
                        name="estrai"
                        label="Estrai"
                        v-model="form[rep][report.code].can_extract"
                        :options="[
                      { value: 'Y', text: 'Sì' },
                      { value: 'N', text: 'No' },
                    ]"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="mostra"
                        label="Mostra Premio"
                        v-model="form[rep][report.code].show_premium"
                        :options="[
                      { value: 'Y', text: 'Sì' },
                      { value: 'N', text: 'No' },
                    ]"
                      />
                    </div>
                  </b-row>
                </b-card>
              </div>
            </b-card-text>
          </b-card>
        </div>
        <div class="form-actions form-actions--sticky">
          <div class="inner-wrapper">
            <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="onSavePermissions"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
            </div>
            <div>
              <b-button
                @click="goBack()"
                class="btn--transparent"
                type="button"
                title="Torna alla pagina precedente"
              >
                <b-icon-chevron-double-left
                  font-scale="0.9"
                ></b-icon-chevron-double-left
                >
                Torna indietro
              </b-button
              >
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import BaseSelect from "@/components/form/BaseSelect";
import {mapGetters} from "vuex";
import {RepositoryFactory} from "@/repositories/RepositoryFactory";

export default {
  mixins: [CustomFiltersMixin],
  data() {
    return {
      isLoading: false,
      repository: "lisa_for_app",
      resource: "lisa_for_apps",
      user: this.$route.params.user,
      lisa_for_apps_reports: [], // this.$store.state.auth.lisa_for_apps,
      treasury: null,
      form: {
        lisa_for_app: {},
      },
    };
  },
  components: {
    BaseSelect,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "lisa-for-apps-edit":
            this.$router.push({
              name: "lisa_for_apps.edit",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    ...mapGetters("auth", {
      getLisaForAppsPermissions: "lisa_for_apps",
    }),
    onSavePermissions() {
      let payload = {
        [this.repository]: {},
      };
      //  POST /api/users/:user/pivot/:lisa_for_app
      // payload = {
      //   lisa_for_app: {
      //     1: {
      //       can_extract: "Y",
      //       show_premium: "Y",
      //     },
      //   },
      // };
      // for (const report in this.form[this.repository]) {
      for (const report of this.lisa_for_apps_reports) {
        payload[this.repository][report.id] = {
          can_extract: this.form[this.repository][report.code].can_extract,
          show_premium: this.form[this.repository][report.code].show_premium,
        };
      }
      this.isLoading = true;
      this.addLisaForAppPermission(this.user.id, this.repository, payload)
        .then(() => {
          this.$store.dispatch("auth/lisa_for_apps");
          this.$showSnackbar({
            preset: "info",
            text: "Permessi aggiornati",
          });
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    addLisaForAppPermission(id, relation, payload) {
      const Repo = RepositoryFactory.get("user");
      return Repo.pivot_store(id, relation, payload);
    },
  },
  beforeMount() {
    this.isLoading = true;
    // load permissions for this user
    const Repo = RepositoryFactory.get(this.repository);
    let queryString = `bySpecifiedUser=${this.user.id}`;
    Repo.index(queryString)
      .then((response) => {
        let data = response.data.data;
        // prepare the form, since api/edit is not available for this resource...
        // hence there is not any beForm or any other related stuff
        data.forEach((e) => {
          if (!this.form[this.repository][e.code]) {
            this.$set(this.form[this.repository], e.code, {});
          }
          this.$set(
            this.form[this.repository][e.code],
            "can_extract",
            e.users.length ? e.users[0].pivot.can_extract.value : "N"
          );
          this.$set(
            this.form[this.repository][e.code],
            "show_premium",
            e.users.length ? e.users[0].pivot.show_premium.value : "N"
          );
          // fill the array to be looped in order to draw the form inputs by v-for above in markup
          this.lisa_for_apps_reports.push({
            id: e.id,
            code: e.code,
            formatted_title: e.formatted_title,
          });
        });
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: errMsg,
        });
        this.isLoading = false;
      });
  },
  created() {
    console.log(this.lisa_for_apps_reports);
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
